export const CONSTANTS = {
  RENEWAL_THRESHOLD_DAYS: 60,
  CIRCLE_RADIUS: 15.9155,
  DESKTOP_BREAKPOINT: 1024,
  MAX_URGENT_CARDS: 2,
  MAX_CONTINUE_CARDS: 1,
  SCROLL_THRESHOLD: 1,
  DEFAULT_VEHICLE_TYPE: 'car',
} as const

export const IMAGES = {
  CAR_WITH_BOW: {
    src: 'https://acko-cms.ackoassets.com/Car_old_version_15bb1d536a.webp',
    alt: 'Car with red bow',
    width: 520,
    height: 320,
  },
  CAR_MOBILE: {
    url: 'https://acko-cms.ackoassets.com/car_mobile_1a405c06d6.webp',
    alt: 'New Car',
    width: 130,
    height: 80,
  },
  FLAG: {
    url: 'https://acko-cms.ackoassets.com/flag_aecc5b81ef.webp',
    alt: 'Logo',
    width: 16,
    height: 18,
  },
  IND: {
    url: 'https://acko-cms.ackoassets.com/IND_3109e2b86a.webp',
    alt: 'IND',
    width: 16,
    height: 8,
  },
  V2_CAR_IMAGE: {
    src: 'https://acko-cms.ackoassets.com/Car_1_3_11cdd3f38d.webp',
    alt: 'car',
    width: 512,
    height: 320,
  },
  V2_CAR_MOBILE: {
    src: 'https://acko-cms.ackoassets.com/Car_1_3_1_5ace6e6f95.webp',
    alt: 'car',
    height: 82,
    width: 82,
  },
} as const

export const TEXT = {
  HEADINGS: {
    MOBILE_MAIN: "Let's insure your car",
    DESKTOP: {
      LETS: "LET'S",
      INSURE: 'INSURE',
      YOUR: 'YOUR',
      CAR: 'CAR',
    },
  },
  V2_HEADING: 'Renew your car insurance\nin just *2 minutes*',
  AWARDS: ['Trusted by \n5 Cr+ Indians', 'Best direct \ninsurer 2025'],
  FORM_LABEL: {
    V1: 'Enter your car registration number',
    V2: 'Enter car registration number',
  },
  CAR_CARDS_SECTION: {
    V1: {
      SECTION_HEADING: 'Did you know? You can get a new car from us and save big!',
      CARDS: [
        {
          TITLE: 'Buying a new car\nsoon?',
          SUBTITLE: '',
          DESCRIPTION: 'See how you can save up to ₹80,000 through our digital showroom',
          FEATURED: false,
        },
        {
          TITLE: 'Booked a new car\nfrom a dealer? ',
          DESCRIPTION: 'Get your brand new car insured before delivery',
          FEATURED: true,
          TEXT: 'See our price',
          BADGE_TEXT: 'Save up to ₹36,000',
        },
      ],
    },
    V2: {
      SECTION_HEADING: 'Save big on your *brand new car’s*\non-road price',
      CARDS: [
        {
          TITLE: 'ACKO Drive\ndigital showroom',
          SUBTITLE: 'Not booked a car yet?',
          DESCRIPTION: 'Compare cars and see how you can save up to ₹80,000 on ACKO Drive',
          FEATURED: false,
          IMG_SRC: 'https://acko-cms.ackoassets.com/ACKO_Drive_wide_0f43e08c1c.svg',
        },
        {
          TITLE: 'Insure your brand\nnew car',
          DESCRIPTION: 'Unlock big savings by insuring your brand new car with ACKO\'s zero-commission insurance',
          FEATURED: true,
          TEXT: 'See our price',
          BADGE_TEXT: 'Save up to ₹36,000',
        },
      ],
    },
  },
  UID: 'UID: 7733 | T&Cs apply*',
} as const

export const VIDEO_DATA = {
  heading: '100% claim settlement is  most important to us when it comes to building trust',
  authorData: {
    authorName: 'Varun Dua',
    authorDesignation: 'Founder',
  },
  videoEventProps: {
    eventName: 'tap_btn_interaction',
    customProperties: {
      type: 'video_play_btn',
      journey: 'Video_Varun_Dua',
    },
  },
  videoSrcSet: {
    lg: 'https://acko-cms.ackoassets.com/Varun_Maddy_2025_bd5d688df4.webm',
    md: 'https://acko-cms.ackoassets.com/Varun_Maddy_2025_bd5d688df4.webm',
    sm: 'https://acko-cms.ackoassets.com/Varun_Maddy_2025_bd5d688df4.webm',
  },
  videoThumbnail: 'https://acko-cms.ackoassets.com/Varun_Dua_Video_thumbnail_8ea3c99b43.webp',
}

export const URLS = {
  HOME: '/',
  ACKODRIVE: 'https://www.ackodrive.com',
  NEW_CAR: '/gi/new-car/vehicle-details',
  RENEWAL_TEMPLATE: (proposalId: string) =>
    `/gi/auto-storefront/renewal/entry?proposal_id=${proposalId}&plan_id=car_comprehensive&product=car&current_node=entry_node`,
  CONTINUE_INSURE_TEMPLATE: (proposalId: string) =>
    `/gi/auto-storefront/fresh-car/checkout-details?proposal_ekey=${proposalId}&current_node=checkout_details_node`,
  FRESH_CAR_TEMPLATE: (ekey: string, registrationNumber: string) =>
    `/gi/auto-storefront/fresh-car?proposal_ekey=${ekey}&current_node=entry_node&registration_number=${encodeURIComponent(
      registrationNumber
    )}`,
} as const

export const ANALYTICS = {
  EVENTS: {
    VIEW_HOMEPAGE: 'view_homepage',
    TRACK_EVENT_COMPLETE: 'track_event_complete',
    TAP_NEW_VEHICLE_CTA: 'tap_new_vehicle_cta',
    TAP_RENEWAL_CARD: 'tap_renewal_card',
    TAP_CONTINUE_INSURE_CARD: 'tap_btn_CTA_widget',
  },
  PRODUCT: {
    CAR: 'car',
    AUTO_CAR: 'auto-car',
  },
  FUNNEL: {
    VISIT: 'visit',
    ENTRY: 'entry',
    CONTINUE_ENTRY: 'continue_entry',
    RENEWAL_ENTRY: 'renewal_entry',
  },
  JOURNEY: {
    VIEW_PAGE_BUY_NEW_CAR_ICON: 'view_page_buy_new_car_icon',
  },
  HEADER_NAME: 'Home',
  V2_HEADER_NAME: 'Home_V2',
  PAGE_TITLE: 'ACKO Insurance | Buy Car, Bike, Health & Travel Insurance Online | Welcome Change',
} as const

export const FORM = {
  V1: {
    PLACEHOLDER: 'e.g. MH05VF1234',
    BUTTON_TEXT: 'Check ACKO price',
    ERROR_MESSAGE: 'Enter your registration number to continue',
    MAX_LENGTH: 10,
    LOADING_TEXT: 'Processing...',
  },
  V2: {
    PLACEHOLDER: 'e.g. KA01AB1234',
    BUTTON_TEXT: 'Check prices',
    ERROR_MESSAGE: 'Enter your registration number to continue',
    MAX_LENGTH: 10,
    LOADING_TEXT: 'Processing...',
  }
}

// Query Parameters
export const QUERY_PARAMS = {
  CAR_NUMBER: 'carNumber',
} as const

// Formatting Configuration
export const FORMATTING = {
  CURRENCY_SYMBOL: '₹',
  LOCALE: 'en-IN',
  CURRENCY_FORMAT_OPTIONS: {
    maximumFractionDigits: 0,
  },
} as const

// Error Messages
export const ERROR_MESSAGES = {
  NO_PROPOSAL_ID: '❌ No proposal_id found in renewal plan data',
  NO_REDIRECT_LINK: '❌ No redirect_link/proposal_id found in recent search data',
} as const

// Component Defaults
export const DEFAULTS = {
  AUTO_SUBMIT: false,
} as const

// Additional Images
export const ADDITIONAL_IMAGES = {
  TICK_ICON: {
    url: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/hero_section_tick_f6f995abe0.svg',
    alt: 'Tag Icon',
    width: 20,
    height: 20,
  },
} as const

// API Endpoints
export const API = {
  ENDPOINTS: {
    PROPOSAL_LIST: '/motororchestrator/api/v2/homepage/proposal_list',
    RENEWAL_PLANS: '/motororchestrator/api/v1/renewals/proposals/plans',
  },
} as const
